/* Athar — Grade → Term → Subject → Product views.
   Reads ?term=1..3 and ?subject=<slug> on a grade collection page and shows the
   matching view. The approved registry comes from [data-athar-registry]; products
   are matched by their tags (data-terms / data-stags). Products never add subjects. */
(function () {
  'use strict';
  var root = document.querySelector('[data-athar-grade]');
  if (!root) return;
  var reg;
  try { reg = JSON.parse(root.querySelector('[data-athar-registry]').textContent); } catch (e) { return; }

  var gradeUrl = root.getAttribute('data-grade-url');
  var gslug = root.getAttribute('data-gslug');
  var gradeTitle = root.getAttribute('data-grade-title');
  var q = new URLSearchParams(location.search);
  var term = parseInt(q.get('term'), 10);
  if (!(term >= 1 && term <= 3)) term = 0;
  var subj = (q.get('subject') || '').toLowerCase().trim();
  if (reg.aliases && reg.aliases[subj]) subj = reg.aliases[subj];
  var S = subj ? reg.subjects[subj] : null;

  /* Clean public routes: /library/<grade>[/term-N][/<subject>] (Shopify URL redirects map
     them to this page; sections/main-404.liquid is the fallback for unmapped ones). */
  function url(t, s) {
    if (!t && !s) return gradeUrl;
    return '/library/' + gslug + (t ? '/term-' + t : '') + (s ? '/' + encodeURIComponent(s) : '');
  }
  function countText(n) {
    var r = n % 100;
    if (n === 1) return 'منتج واحد';
    if (n === 2) return 'منتجان';
    if (r >= 3 && r <= 10) return n + ' منتجات';
    return n + ' منتجًا';
  }
  /* Show the clean public route in the address bar (not inside the theme editor) */
  function pretty(path) {
    if (window.Shopify && window.Shopify.designMode) return;
    try { history.replaceState(null, '', path); } catch (e) {}
  }
  function show(name) {
    root.querySelectorAll('[data-view]').forEach(function (v) { v.hidden = v.getAttribute('data-view') !== name; });
  }
  function link(text, href) {
    var li = document.createElement('li');
    if (href) { var a = document.createElement('a'); a.href = href; a.textContent = text; li.appendChild(a); }
    else { li.textContent = text; li.setAttribute('aria-current', 'page'); }
    return li;
  }

  /* Term chips keep the current subject */
  document.querySelectorAll('[data-term-chip]').forEach(function (a) {
    var t = parseInt(a.getAttribute('data-term-chip'), 10);
    a.href = url(t, S ? subj : '');
    if (t === term) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
  });

  /* Breadcrumb: Home › Library › Grade › Term › Subject */
  var ol = document.querySelector('[data-bc]');
  if (ol && (term || S)) {
    ol.removeChild(ol.lastElementChild);
    ol.appendChild(link(gradeTitle, gradeUrl));
    if (term) ol.appendChild(link(reg.terms[term], S ? url(term, '') : null));
    if (S) ol.appendChild(link(S.ar, null));
  }

  /* Back links */
  root.querySelectorAll('[data-href="grade"]').forEach(function (a) { a.href = gradeUrl; });
  root.querySelectorAll('[data-href="term"]').forEach(function (a) { a.href = url(term, ''); });

  /* ---- Grade / Term view ---- */
  if (!subj) {
    show('grade');
    root.querySelectorAll('[data-term-block]').forEach(function (b) {
      b.hidden = !!term && parseInt(b.getAttribute('data-term-block'), 10) !== term;
    });
    if (term) pretty(url(term, ''));
    return;
  }

  /* ---- Subject not approved for this grade ---- */
  if (!S) { show('unapproved'); return; }

  /* ---- Subject view ---- */
  show('subject');
  var hero = root.querySelector('[data-hero]');
  hero.style.setProperty('--s1', S.c1); hero.style.setProperty('--s2', S.c2); hero.style.setProperty('--s3', S.c3);
  var art = root.querySelector('[data-hero-art]');
  if (S.img) { var im = new Image(); im.src = S.img; im.width = 128; im.height = 128; im.alt = ''; art.appendChild(im); }
  else { var g = document.createElement('span'); g.className = 'subj-card__glyph'; g.textContent = S.glyph; art.appendChild(g); }
  root.querySelector('[data-hero-meta]').textContent = gradeTitle + (term ? ' · ' + reg.terms[term] : '');
  root.querySelector('[data-hero-ar]').textContent = S.ar;
  root.querySelector('[data-hero-en]').textContent = S.en;

  var cards = [].slice.call(root.querySelectorAll('[data-type-grid] [data-ptype]'));
  var mine = cards.filter(function (c) {
    var tags = (' ' + (c.getAttribute('data-stags') || '') + ' ');
    var terms = (' ' + (c.getAttribute('data-terms') || '') + ' ');
    return tags.indexOf(' ' + S.tag + ' ') > -1 && (!term || terms.indexOf(' ' + term + ' ') > -1);
  });
  cards.forEach(function (c) { c.hidden = mine.indexOf(c) === -1; });
  var total = mine.length;
  root.querySelector('[data-hero-count]').textContent = total ? countText(total) : 'قريبًا';
  document.title = S.ar + ' – ' + gradeTitle + (term ? ' – ' + reg.terms[term] : '') + ' | ' + document.title.split('|').pop().trim();

  if (!total) {
    root.querySelector('[data-subject-empty]').hidden = false;
  } else {
    root.querySelector('[data-subject-has]').hidden = false;
    var bar = root.querySelector('[data-type-filters]');
    var btns = [].slice.call(bar.querySelectorAll('[data-type-filter]'));
    var empty = root.querySelector('[data-type-empty]');
    btns.forEach(function (b) {
      var t = b.getAttribute('data-type-filter');
      var n = t === 'all' ? total : mine.filter(function (c) { return c.getAttribute('data-ptype') === t; }).length;
      b.querySelector('[data-n]').textContent = n;
      b.hidden = n === 0; /* types with no published products stay hidden; they appear automatically later */
    });
    var apply = function (type) {
      var shown = 0;
      mine.forEach(function (c) { var ok = type === 'all' || c.getAttribute('data-ptype') === type; c.hidden = !ok; if (ok) shown++; });
      btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-type-filter') === type)); });
      if (empty) empty.hidden = shown > 0;
    };
    btns.forEach(function (b) { b.addEventListener('click', function () { apply(b.getAttribute('data-type-filter')); }); });
    var reset = root.querySelector('[data-type-reset]');
    if (reset) reset.addEventListener('click', function (e) { e.preventDefault(); apply('all'); });
  }

  pretty(url(term, subj));
})();
